import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import RoadmapRow from "./PfRoadmap_rows";
import Toast from "./Toast";

import CalculatorBudget from "./CalculatorBudget";
import CalculatorValuation from "./CalculatorValuation";
import CalculatorFunding from "./CalculatorFunding";


export default function PfRoadmap({ onDirtyChange }) {
  const [form, setForm] = useState({ vision: "" });

const [roadmap, setRoadmap] = useState([
  { fy: "", stage: "", activity: "", budget: "", budgetBreakdown: [], valuation: "", valuationBreakdown: [], funding: "" },
]);

  const [initialForm, setInitialForm] = useState({});
  const [initialRoadmap, setInitialRoadmap] = useState([]);
  const [isDirty, setIsDirty] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [saveType, setSaveType] = useState("success");
  const [confirmIndex, setConfirmIndex] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;
    fetch(`${process.env.REACT_APP_API_BASE_URL}/projects`)
      .then((res) => res.json())
      .then((data) => {
        const project = (data.lists || []).find((p) => String(p.id) === String(id));
        if (project) {
          setForm({ vision: project.vision || "" });

          const loadedRoadmap = [];
          for (let i = 1; i <= 5; i++) {


          loadedRoadmap.push({
  fy: project[`fy${i}`] || "",
  stage: project[`stage${i}`] || "",
  activity: project[`rmy${i}`] || "",
  budget: project[`budget${i}`] || "",
  budgetBreakdown: (() => {
    try {
      return JSON.parse(project[`budgetBreakdown${i}`] || "[]");
    } catch {
      return [];
    }
  })(),
  funding: project[`funding${i}`] || "",
});


      }

          setRoadmap(loadedRoadmap);
          setInitialForm({ vision: project.vision || "" });
          setInitialRoadmap(loadedRoadmap);
        }
      });
  }, [id]);

  useEffect(() => {
    const roadmapChanged = JSON.stringify(roadmap) !== JSON.stringify(initialRoadmap);
    const formChanged = JSON.stringify(form) !== JSON.stringify(initialForm);
    setIsDirty(roadmapChanged || formChanged);
  }, [form, roadmap]);

  useEffect(() => {
    if (typeof onDirtyChange === "function") {
      onDirtyChange(isDirty);
    }
  }, [isDirty]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleRoadmapChange = (index, field, value) => {
    setRoadmap((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );
  };



  const handleAddYear = () => {
  const nextFY = `FY ${2025 + roadmap.length}`;
  setRoadmap((prev) => [...prev, { fy: nextFY, activity: "", budget: "", funding: "" }]);
};


  const handleRemoveYear = (index) => setConfirmIndex(index);
  const confirmRemove = () => {
    setRoadmap((prev) => prev.filter((_, i) => i !== confirmIndex));
    setConfirmIndex(null);
  };
  const cancelRemove = () => setConfirmIndex(null);

  const handleCancel = () => {
    setForm(initialForm);
    setRoadmap(initialRoadmap);
    setSaveMessage("");
    if (onDirtyChange) onDirtyChange(false);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSaveMessage("");

    const fd = new FormData();
    fd.append("vision", form.vision);

roadmap.forEach((year, i) => {
  fd.append(`fy${i + 1}`, year.fy);
  fd.append(`stage${i + 1}`, year.stage);
  fd.append(`rmy${i + 1}`, year.activity);
  fd.append(`budget${i + 1}`, year.budget);
  fd.append(`budgetBreakdown${i + 1}`, JSON.stringify(year.budgetBreakdown || [])); // NEW
  fd.append(`funding${i + 1}`, year.funding);
});


    if (id) fd.append("id", id);

    const endpoint = id ? "updateProject" : "addProject";

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/${endpoint}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${process.env.REACT_APP_ADMIN_TOKEN}` },
        body: fd,
      });

      const text = await res.text();
      const data = JSON.parse(text || "{}");

      if (data.success) {
        setInitialForm(form);
        setInitialRoadmap(roadmap);
        setSaveMessage("✅ Saved successfully!");
        setSaveType("success");
        if (onDirtyChange) onDirtyChange(true);
      } else {
        setSaveMessage("❌ Save failed");
        setSaveType("error");
      }
    } catch (err) {
      console.error("Network error:", err);
      setSaveMessage("❌ Network error");
      setSaveType("error");
    } finally {
      setLoading(false);
      setIsDirty(false);
    }
  };

  // Budget popup state
  const [budgetPopupIndex, setBudgetPopupIndex] = useState(null);
  const [budgetBreakdowns, setBudgetBreakdowns] = useState({});

  
  const handleBudgetSave = ({ total, breakdown }) => {
  const index = budgetPopupIndex;
  setRoadmap(prev =>
    prev.map((row, i) =>
      i === index ? { ...row, budget: total, budgetBreakdown: breakdown } : row
    )
  );
  setBudgetPopupIndex(null);
};



const [valuationPopupIndex, setValuationPopupIndex] = useState(null);

const handleValuationSave = ({ stage, total, breakdown }) => {
  const index = valuationPopupIndex;
  setRoadmap(prev =>
    prev.map((row, i) =>
      i === index ? { ...row, stage, valuation: total, valuationBreakdown: breakdown } : row
    )
  );
  setValuationPopupIndex(null);
};


const [fundingPopupIndex, setFundingPopupIndex] = useState(null);

const handleFundingSave = ({ stage, investors, totalRaised, postMoneyValuation, dilutionPercent, ownerDilution }) => {
  const index = fundingPopupIndex;
  setRoadmap(prev =>
    prev.map((row, i) =>
      i === index ? { ...row, funding: totalRaised, investors, postMoneyValuation, dilutionPercent, ownerDilution } : row
    )
  );
  setFundingPopupIndex(null);
};

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        style={{
          border: isDirty ? "2px dotted red" : "none",
          padding: "10px",
        }}
      >
        <div className="form-row">
          <label>Vision</label>
          <input
            name="vision"
            value={form.vision}
            onChange={handleFormChange}
            className="w3-input w3-border"
          />
        </div>

        <label>Roadmap</label>
<table className="w3-table-all" style={{ width: "100%" }}>
       <thead>
  <tr>
    <th style={{ width:"5%"}}>#</th>
    <th style={{ width:"10%"}}>FY</th>
    <th style={{ width:"15%"}}>Stage</th>
    <th style={{width: "50%"}}>Milestone</th>
    <th style={{ width:"15%"}}>Budget</th>
    <th className="w3-hide">Valuation<br /> (Pre-Money) </th>   {/* NEW COLUMN */}
    <th className="w3-hide">Funding</th>
    <th>x</th>
  </tr>
</thead>


          <tbody>
            {roadmap.map((year, i) => (
  <RoadmapRow
  key={i}
  index={i}
  data={year}
  onChange={handleRoadmapChange}
  onRemove={handleRemoveYear}
  onOpenBudget={() => setBudgetPopupIndex(i)}
  onOpenValuation={() => setValuationPopupIndex(i)}
  onOpenFunding={() => setFundingPopupIndex(i)}   // NEW
/>



            ))}
          </tbody>
        </table>

<div className="w3-row w3-padding-16" >
<div className="w3-half">
        <button
          type="button"
          className="w3-button w3-indigo"
          onClick={handleAddYear}
          style={{ }}
        >
          + Add Roadmap
        </button>
</div>

        <div className="w3-half">
          
       

          <button
            className="w3-right w3-button w3-teal"
            style={{ marginRight: 10 }}
            type="submit"
            disabled={!isDirty || loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
 
   <button
            type="button"
            className="w3-right btn-muted"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
        </div>

        <Toast
          message={saveMessage}
          type={saveType}
          onClose={() => setSaveMessage("")}
        />
      </form>

      {budgetPopupIndex !== null && (
  <CalculatorBudget
    initialRows={roadmap[budgetPopupIndex]?.budgetBreakdown || []}
    onSave={handleBudgetSave}
    onCancel={() => setBudgetPopupIndex(null)}
  />
)}


  

{valuationPopupIndex !== null && (
  <CalculatorValuation
    initialStage={roadmap[valuationPopupIndex]?.stage || ""}
    budgetItems={roadmap[valuationPopupIndex]?.budgetBreakdown || []}
    initialRows={roadmap[valuationPopupIndex]?.valuationBreakdown || []}
    onSave={handleValuationSave}
    onCancel={() => setValuationPopupIndex(null)}
  />
)}

{fundingPopupIndex !== null && (
  <CalculatorFunding
    stage={roadmap[fundingPopupIndex]?.stage || ""}
    preMoneyValuation={roadmap[fundingPopupIndex]?.valuation || 0}
    ownerShares={100} // adjust based on your cap table
    esopShares={10}   // adjust if ESOP pool exists
    onSave={handleFundingSave}
    onCancel={() => setFundingPopupIndex(null)}
  />
)}

    {confirmIndex !== null && (
        <div
          style={{
            position: "fixed",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 10000,
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <p>Are you sure you want to remove Year {confirmIndex + 1}?</p>
          <button className="w3-button w3-red" onClick={confirmRemove}>
            Yes, Remove
          </button>
          <button
            className="w3-button w3-light-grey"
            onClick={cancelRemove}
            style={{ marginLeft: 10 }}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}
